<template>
  <div
    v-if="error"
    class="absolute"
  >
    <p class="text-xs text-primary-700">
      {{ $t(error) }}
    </p>
  </div>
</template>

<script setup lang="ts">
interface Props {
  error?: string;
}

defineProps<Props>();
</script>
